import { FC } from 'react';
import styled from 'styled-components';
import { Caption, textColors, spacing } from 'ui/theme';
import { RelativeTime } from 'ui/utility/relativeTime';

export const LAST_SAVED_TEXT_TEST_ID = 'last-saved-text';
export const LAST_SAVED_TEXT = 'Last saved';

const StyledCaption = styled(Caption)`
  color: ${textColors.textSecondary};
`;

const StyledRelativeTime = styled(RelativeTime)`
  margin-left: ${spacing.eighth};
`;

interface LastSavedTextProps {
  /** The timestamp that it was last saved */
  timestamp?: string;
  /** Custom text for label */
  customText?: string;
}

export const LastSavedText: FC<React.PropsWithChildren<LastSavedTextProps>> = ({
  timestamp,
  customText,
}: LastSavedTextProps) => {
  if (!timestamp) return null;

  return (
    <StyledCaption data-test={LAST_SAVED_TEXT_TEST_ID}>
      {customText || LAST_SAVED_TEXT} <StyledRelativeTime timestamp={timestamp} />
    </StyledCaption>
  );
};
